const prefix = '/auth';
const providersPrefix = '/providers';
const socialPrefix = '/social';
const onboardingPrefix = '/onboarding';

const ApiRoutes = {
  Login: prefix + '/login',
  Register: prefix + '/register',
  CheckEmail: prefix + '/check-email',
  Logout: prefix + '/logout',
  RequestPasswordReset: prefix + '/request-password-reset',
  ResetPassword: prefix + '/reset-password',
  ValidateResetToken: prefix + '/validate-reset-token',
  VerifyEmail: prefix + '/verify-email',
  ResendVerificationEmail: prefix + '/resend-verification-email',
  GoogleRedirect: prefix + '/google/redirect',
  GoogleCallback: prefix + '/google/callback',
  FacebookRedirect: prefix + '/facebook/redirect',
  FacebookCallback: prefix + '/facebook/callback',
  Me: prefix + '/me',
  GetRegistrationProgress: prefix + '/registration-progress',
  UpdatePersonalInfo: prefix + '/update-personal-info',
  UpdateAddress: prefix + '/update-address',
  CompleteRegistration: prefix + '/complete-registration',
  OnboardingStatus: prefix + onboardingPrefix + '/status',
  UpdateOnboardingStep: prefix + onboardingPrefix + '/update-step',
  SkipOnboardingStep: prefix + onboardingPrefix + '/skip-step',
  Social: `${prefix}${socialPrefix}`,
  GetAuthUrl: (provider: string) => `${prefix}${socialPrefix}/${provider}/get-auth-url`,
  ProviderCallback: (provider: string) => `${prefix}${socialPrefix}/${provider}/callback`,
  RequestLinkingApproval: providersPrefix + '/link-request',
  ConfirmLinking: providersPrefix + '/confirm-linking',
  RejectLinking: providersPrefix + '/reject-linking',
  GetConnectedProviders: providersPrefix + '/connected',
  DisconnectProvider: (provider: string) => `${providersPrefix}/${provider}/disconnect`,
};

export default ApiRoutes;
